// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"17624ea0","744":"2e788d55"}[chunkId] + ".chunk.css";
};